import {EnvelopeNewIcon} from 'shells/icon/svg/envelope-new-icon';
import {LayoutRegularIcon} from 'shells/icon/svg/layout-regular-icon';
// @ts-expect-error
import {RetryRegularIcon} from 'shells/icon/svg/retry-regular-icon';
import {TrashRegularIcon} from 'shells/icon/svg/trash-regular-icon';
import type {SelectMenuOption} from 'shells/select-menu/select-menu';

export function getActionMenuOptions(
    isSoftDeleted: boolean,
    userFacingEntityType: 'company' | 'person',
    onDelete: () => Promise<any>,
    onUndelete: () => Promise<any>,
    onPermanentlyDeleteClick: () => void,
    onUnsubscribeFromAllClick: () => void,
    isUnsubscribedFromAll?: boolean,
    onCustomizeLayout?: () => void
): SelectMenuOption[] {
    const options: SelectMenuOption[] = [];

    if (onCustomizeLayout) {
        options.push({
            label: 'Customize layout',
            handleSelect: onCustomizeLayout,
            icon: <LayoutRegularIcon size={18} wrapWithDiv={false} />,
        });
    }

    if (
        NutClientConfig.hasSmsAudiencesFF &&
        userFacingEntityType === 'person' &&
        isUnsubscribedFromAll === false
    ) {
        options.push({
            label: 'Unsubscribe from all',
            handleSelect: () => {
                onUnsubscribeFromAllClick();
            },
            icon: <EnvelopeNewIcon size={18} wrapWithDiv={false} />,
        });
    }

    if (isSoftDeleted) {
        options.push(
            {
                label: `Restore ${userFacingEntityType}`,
                handleSelect: () => {
                    onUndelete();
                },
                icon: <RetryRegularIcon size={18} wrapWithDiv={false} />,
            },
            {
                label: `Permanently delete ${userFacingEntityType}`,
                handleSelect: () => {
                    onPermanentlyDeleteClick();
                },
                variant: 'destructive',
                icon: <TrashRegularIcon size={18} wrapWithDiv={false} />,
            }
        );
    } else {
        options.push({
            label: `Delete ${userFacingEntityType}`,
            handleSelect: () => {
                onDelete();
            },
            variant: 'destructive',
            icon: <TrashRegularIcon size={18} wrapWithDiv={false} />,
        });
    }

    return options;
}
